import { getDisclaimer } from '@/services/disclaimer';
import {
  DisclaimerAPIResponse,
  DisclaimerRequestParams,
} from '@/types/disclaimer';
import { createQuery } from 'react-query-kit';

export const useGetDisclaimer = createQuery<
  DisclaimerAPIResponse,
  DisclaimerRequestParams,
  Error
>({
  primaryKey: 'disclaimer',
  queryFn: ({ queryKey: [primaryKey, variables] }) => {
    return getDisclaimer(variables);
  },
});
